import { useRouter } from 'next/router';
import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import Loader from '../src/components/loader';
import Head from 'next/head';
import cookie from 'js-cookie';
import VisualSearch2 from '../src/components/visualSearch2';

function Four0four() {
    const [loading, setLoading] = useState(true);
    const [base64content, setbase64content] = useState('');
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  // Handle file selection and validate MIME type
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    // Check if a file is selected
    if (file) {
      try {
        const base64String = await convertToBase64(file);
        setbase64content(base64String)
        // console.log('Base64 type:', base64String.split(',')[0]); // Debugging purpose
        // console.log('Base64 String:', base64String.split(',')[1]); // Debugging purpose
        event.target.value = null;
        // Now you can use base64String for your API call
      } catch (error) {
        console.log('Error converting image to base64:', error);
      }
    }
  }

    return (
        <>
            <Head>
                <title>Samelook</title>
                <meta name="title" content='Samelook'/>
                <meta name="description" content='Discover similer tiles'/>
            </Head>
            {base64content && <VisualSearch2 base64={base64content} setbase64content={setbase64content}/>}
            <section className="same_look">
             <div className="container">
               <div className="same_look_wrap flex-css">
               <div className="same_look_img">
                  <h2>Looking for a specific pattern/color ?</h2>
                  <img src="../similar-look-home.webp"  alt='image'/>
                  <span className="default-btn --syte-start-camera-upload hide-sm">
        <label style={{ cursor: 'pointer' }}>
        Upload an Image
                  <input
            type="file"
            accept="image/jpeg, image/png, image/tiff" // Restrict the accepted file types
            onChange={handleFileChange}
            style={{ display: 'none' }} // Hide the input field
          />
        </label>
      </span>                </div>
                <div className="same_look_data">
                  <h2>Looking for a specific pattern/color ?</h2>
                  <p>We help you visually search for similar color or design patterns. Check it out now</p>
                  {/* <span className="default-btn --syte-start-camera-upload hide-sm">Click to upload an image to Upload an Image</span> */}
                  <span className="default-btn --syte-start-camera-upload hide-sm">
        <label style={{ cursor: 'pointer' }}>
        Upload an Image
                  <input
            type="file"
            accept="image/jpeg, image/png, image/tiff" // Restrict the accepted file types
            onChange={handleFileChange}
            style={{ display: 'none' }} // Hide the input field
          />
        </label>
      </span>
                </div>
                
               </div>
             </div>
            </section>
        </>
    );
}

export default Four0four;
